// removed by extract-text-webpack-plugin
module.exports = {"root":"_11MSD_11"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Parcel/components/NoParcel/NoParcel.css
// module id = 773
// module chunks = 0